import React, { FC } from 'react'

import classes from './styles.module.scss';
import { ChevronRightIcon } from '../../assets/icons';

interface IProps {
    title: string;
    subtitle?: string;
    onClick?: () => void;
    children: React.ReactNode;
}

const Card: FC<IProps> = ({ title, subtitle, children, onClick }) => {
    return (
        <div className={classes.card}>
            <div className={classes.card__header}>
                <div className={classes.card__text}>
                    <span className={classes.card__title}>{title}</span>
                    {subtitle && <span className={classes.card__subtitle}>{subtitle}</span>}
                </div>
                {
                    onClick && <div className={classes.card__icon} onClick={onClick}>
                        <ChevronRightIcon />
                    </div>
                }
            </div>
            <div className={classes.card__content}>
                {children}
            </div>
        </div>
    )
}

export default Card